import { trackpointMetrics } from 'lib/metricsCalculator'
import _ from 'lodash'

export const trimEnds = (troute, leftI, rightI) => {
  const { rawPoints } = troute

  const trimmed = _.slice(rawPoints, leftI, rightI + 1)
  return troute.set('rawPoints', trimmed).set('trackPoints', trackpointMetrics(trimmed))
}

export const deleteSelection = (troute, leftI, rightI) => {
  const { rawPoints } = troute

  // both rawPoints[leftI] and rawPoints[rightI] should be removed
  // _.slice(array, start, end) results in [start, end)
  const leftOfSelection = leftI > 0 ? _.slice(rawPoints, 0, leftI) : []
  const rightOfSelection = rightI < rawPoints.length ? _.slice(rawPoints, rightI + 1, rawPoints.length + 1) : []
  const withoutSelection = _.concat(leftOfSelection, rightOfSelection)
  return troute.set('rawPoints', withoutSelection).set('trackPoints', trackpointMetrics(withoutSelection))
}

export const flattenTripElevation = (trip, startIndex, endIndex) => {
  // trip rawPoints can have missing elevation values, so we pull metrics from trackPoints
  const { trackPoints, rawPoints } = trip

  const a = trackPoints[startIndex]
  const b = trackPoints[endIndex]
  const slope = (b.ele - a.ele) / (b.distance - a.distance)

  const before = rawPoints.slice(0, startIndex)
  const tpToFlatten = trackPoints.slice(startIndex, endIndex)
  const rpToFlatten = rawPoints.slice(startIndex, endIndex)
  const after = rawPoints.slice(endIndex)

  const flattenedRawPoints = tpToFlatten.map((p, idx) => (
    Object.assign({}, rpToFlatten[idx], { e: (p.distance - a.distance) * slope + a.ele, d: p.distance })
  ))

  const rawPointsWithFlattened = before.concat(flattenedRawPoints, after)
  return trip.set('rawPoints', rawPointsWithFlattened).set('trackPoints', trackpointMetrics(rawPointsWithFlattened))
}
